import React from "react";
import { Link } from "react-router-dom";
import { heroImage, aboutImage, contact } from "../mock";
import ContactForm from "../components/ContactForm";

const Home = () => {
  return (
    <div>
      {/* HERO */}
      <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url(${heroImage})`,
          }}
        />
        <div className="absolute inset-0 bg-black/55" />
        <div className="relative z-10 text-center px-6 fade-up">
          <p className="text-[#f5f1e8] tracking-[0.4em] text-sm mb-6">THIS IS</p>
          <h1 className="font-display text-6xl md:text-8xl lg:text-9xl text-[#e8a13a] font-bold tracking-wide">
            BRAINS ON TAP
          </h1>
          <p className="mt-6 text-[#f5f1e8] tracking-[0.35em] text-lg md:text-2xl font-light">
            THE NON-LECTURE EXPERIENCE
          </p>
          <p className="mt-8 text-[#f5f1e8] font-serif-italic text-xl md:text-2xl max-w-3xl mx-auto">
            This is where real people, teach real things, in relaxed social spaces.
          </p>
          <a
            href="#learn-more"
            className="inline-block mt-10 border-2 border-[#e8a13a] text-[#e8a13a] hover:bg-[#e8a13a] hover:text-[#0f0f10] px-10 py-3 text-sm tracking-[0.3em] font-semibold transition-colors"
          >
            LEARN MORE
          </a>
        </div>
      </section>

      {/* Ticker text */}
      <div className="bg-[#0f0f10] py-10 overflow-hidden border-y border-[#2a2a2a]">
        <div className="marquee-track font-display text-5xl md:text-7xl text-[#e8a13a]/25 whitespace-nowrap">
          {Array.from({ length: 8 }).map((_, i) => (
            <span key={i} className="px-8">BRAINS ON TAP</span>
          ))}
          {Array.from({ length: 8 }).map((_, i) => (
            <span key={`b-${i}`} className="px-8">BRAINS ON TAP</span>
          ))}
        </div>
      </div>

      {/* About */}
      <section id="learn-more" className="py-24 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-display text-3xl md:text-5xl text-[#e8a13a] mb-16 leading-tight">
            This is turning small talk<br />into smart conversations.
          </h2>
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="overflow-hidden group">
              <img
                src={aboutImage}
                alt="Community talk"
                className="w-full h-[420px] object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="space-y-5 text-[#d5c9a8] leading-relaxed">
              <h3 className="font-display text-2xl text-[#f5f1e8]">
                Let's talk about the Non-Lecture Experience.
              </h3>
              <p>
                <strong className="text-[#f5f1e8]">Brains On Tap: The Non-Lecture Experience</strong> is a community-powered learning series that brings real people together to share real ideas in relaxed, social spaces. Imagine for a moment if TedTalks, Podcasting, Networking and Happy Hour had a baby... THAT'S Brains On Tap.
              </p>
              <p>
                We host engaging, thought-provoking talks (not lectures) in breweries and pubs. These talks are delivered by storytellers, educators, and passionate subject matter experts.
              </p>
              <p>
                Consider these events meaningful conversations with curious minds, with a pint (or two) if that's your thing — but it doesn't have to be! BOT is rooted in the belief that education and life-long learning doesn't have to happen in a formal classroom setting delivered by someone with a PhD.
              </p>
              <p>
                Brains on Tap is reimagining how we connect and build community around the topics we love to nerd out about... together!
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA banner */}
      <section className="py-20 px-6 bg-[#181818] border-y border-[#2a2a2a]">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-5xl text-[#e8a13a] mb-6">
            This is Where Nerdy People Go to Have Fun.
          </h2>
          <div className="flex flex-wrap gap-4 justify-center mt-8">
            <Link to="/become-a-speaker" className="border border-[#e8a13a] text-[#e8a13a] hover:bg-[#e8a13a] hover:text-[#0f0f10] px-6 py-3 text-sm tracking-widest transition-colors">BECOME A SPEAKER</Link>
            <Link to="/become-a-volunteer" className="border border-[#e8a13a] text-[#e8a13a] hover:bg-[#e8a13a] hover:text-[#0f0f10] px-6 py-3 text-sm tracking-widest transition-colors">VOLUNTEER</Link>
            <Link to="/host-a-bot-event" className="border border-[#e8a13a] text-[#e8a13a] hover:bg-[#e8a13a] hover:text-[#0f0f10] px-6 py-3 text-sm tracking-widest transition-colors">HOST AN EVENT</Link>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section className="py-24 px-6">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16">
          <div>
            <h3 className="font-display text-2xl text-[#f5f1e8] mb-4">Thank you for your interest in BOT.</h3>
            <p className="text-[#d5c9a8] leading-relaxed mb-6">
              We'd love to hear from you! Whether you're interested in speaking, hosting, partnering, or just curious about what Brains on Tap is all about — send us a message.
            </p>
            <h4 className="font-display text-lg text-[#e8a13a] mb-3">
              Feel free to text, email or DM on social media:
            </h4>
            <div className="space-y-2">
              <a href={`tel:${contact.phone}`} className="block text-[#f5f1e8] hover:text-[#e8a13a] transition-colors">
                {contact.phone}
              </a>
              <a href={`mailto:${contact.email}`} className="block text-[#f5f1e8] hover:text-[#e8a13a] transition-colors">
                {contact.email}
              </a>
            </div>
          </div>
          <div>
            <ContactForm
              title="Join The Brains Community!"
              storageKey="bot_community_join"
              withAttachments
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
